import React from 'react'
import { connect } from 'react-redux'
import { I18nProvider } from '@lingui/react'
import { allLocales } from 'store/actions/locale'

const mapStateToProps = state => {
  return {
    locale: state.locale.get('active'),
  }
}
export default connect(mapStateToProps)(class LocaleLoader extends React.Component {
  static propTypes = {
    locale: PropTypes.oneOf(allLocales),
  }

  static defaultProps = {
    locale: 'en-us',
  }

  state = {
    catalogs: {},
  }

  componentDidMount() {
    const { locale } = this.props
    this.loadCatalog(locale)
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { locale: nextLocale } = nextProps
    const { catalogs } = nextState
    const { locale } = this.props

    if(nextLocale !== locale && !catalogs[nextLocale]) {
      this.loadCatalog(nextLocale)
      return false
    }

    return true
  }

  loadCatalog = async (locale) => {
    // eslint-disable-next-line function-paren-newline
    const catalog = await import(
      /* webpackMode: "lazy", webpackChunkName: "i18n-[index]" */
      `@lingui/loader!locale/${locale}/messages.json`
    )

    this.setState(state => ({
      catalogs: {
        ...state.catalogs,
        [locale]: catalog
      }
    }))
  }

  render() {
    const { children, locale } = this.props
    const { catalogs } = this.state

    // Skip rendering when catalog isn't loaded.
    if(!catalogs[locale]) return null

    return (
      <I18nProvider language={locale} catalogs={catalogs}>
        {children}
      </I18nProvider>
    )
  }
})
